import React from "react";
import { Spinner, Button, Intent } from "@blueprintjs/core";
import { observer, inject } from "mobx-react";
import JobEmpty from 'components/Job/JobEmpty';

const initialsOf = (name = '') =>
  String(name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('');

@inject("store", "viewStore", "activityStore")
@observer
class JobsActivityLogs extends React.Component {
  componentDidMount() {
    this.fetchActivities(false);
  }

  componentDidUpdate(prevProps) {
    const previousId = prevProps.job?.attributes?.id;
    const nextId = this.props.job?.attributes?.id;
    if (nextId && nextId !== previousId) {
      this.fetchActivities(false);
    }
  }

  fetchActivities(hasMoreRecords) {
    let { job } = this.props;
    let { activityStore } = this.props;
    activityStore.loadActivityLogs(job.attributes.id, hasMoreRecords);
  }

  render() {
    let {
      activityStore: {
        jobActivityLogs: { objects, isLoading, meta, isLoadingMore},
      },
    } = this.props;
    const canLoadMore = meta.page < meta.total_pages;
    if (isLoading) {
      return (
        <div className="spinner-center">
          <Spinner size="25" />
        </div>
      );
    }
    if (objects.length === 0) {
      return (
        <JobEmpty kind="activity" />
      );
    }
    return (
      <div>
        <div className="activityTimelineLogs">
          {objects.map((activity) => {
            return (
              <div className={`activityTimelineCard ${activity.attributes.message.color_class} rightView`}>
                <div className="timelineCard">
                  <div className="activityCard">
                    <div width="10px" className="customerAvatar">
                      <span className="jp-initials" aria-hidden="true">{initialsOf(activity.attributes.owner.name)}</span>
                    </div>
                    <div className="activityMessageWrap">
                      <div className="activtiyHeader" width="150px">
                        <p className="activityTitle">
                          #{activity.attributes.job.number}
                        </p>
                        <p className="activityDate">
                          {activity.attributes.formatted_created_at}
                        </p>
                      </div>
                      <div className="activityMessage">
                        <p className="message">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: activity.attributes.message.html,
                            }}
                          ></div>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {canLoadMore && <div className="activityLoadMoreBtn">
          <Button
            intent={Intent.PRIMARY}
            loading={isLoadingMore}
            onClick={() => {
              !isLoadingMore && this.fetchActivities(true)
            }}
          >
            Load More
          </Button>
        </div>}
      </div>
    );
  }
}

export default JobsActivityLogs;
